import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { pageAction } from '../redux_files/actions/page_actions';


const Disclaimer = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    document.title = 'Disclaimer';
    dispatch(pageAction('Disclaimer'));
  });
  return (
    <div className='container'>
      <div className='outer-border pd-20'>
The content on this website is provided `as is` and is for general information purposes only. While we strive to ensure accuracy and quality, Shivay Durga Foods makes no guarantees about the completeness, reliability, or suitability of any information provided.
<br /><br />
Food descriptions and images are representative and may vary based on availability and region. We are not liable for any errors or delays in service due to external factors beyond our control (such as traffic, weather, or third-party delivery platforms).
<br /><br />
Thank you for choosing Shivay Durga Foods!
      </div>
    </div>
  );
};
export default Disclaimer;
